import request, { toQueryString } from './http';
//?! VALIDATE PRICE
import { validateHotelAmount } from '@shared/services/servicesAux';
//?! VALIDATE PRICE

import store from '@shared/redux/store';
import { saveSearchBody, setSearchLink } from '@shared/redux/actions';

export const getCities = params => {
  return request({
    url: `/hotels/cities`,
    params: { ...params },
  });
};

export const getProvinces = () => {
  return request({
    method: 'GET',
    url: `/users/provinces`,
  });
};

export const getHotels = body => {
  return request({
    method: 'POST',
    url: `/rules/hotels/search-lodging`,
    data: body,
  });
};

export const getFastHotels = body => {
  return request({
    method: 'POST',
    url: `/rules/hotels/fast-search`,
    data: body,
  });
};

// export const getHotels = () => {
//   return Promise.resolve(require('/home/romi/Descargas/normal-ROMA.json'));
// };

// export const getFastHotels = () => {
//   return Promise.resolve(require('/home/romi/Descargas/fast-ROMA.json'));
// };

export const getHotelsDetail = (params, headers) => {
  return request({
    url: `/rules/hotels/${params.id_hotel}/detailstabs?id_integration=${params.id_integration}&hotel_code=${params.hotel_code}&id_city=${params.id_city}&id_provider=${params.id_provider}`,
    headers: { ...headers },
  });
};

//?! VALIDATE PRICE
export const postValidateHotelAmount = async ({
  id_integration,
  idProduct,
  price,
  hotel,
  step,
  ratesAndBase,
}) => {
  // Solo valida para esta integración
  if (+id_integration !== 1) {
    return true;
  }

  try {
    const priceValidation = await validateHotelAmount({
      idProduct,
      price,
      hotel,
      step,
      ratesAndBase,
    });

    const validated = Boolean(priceValidation?.validated);

    if (!validated) {
      console.log('ERROR to validate amount');
      console.log(priceValidation);
    }

    return validated;
  } catch (error) {
    console.log('Error validating amount', error);
    return false;
  }
};

export const getHotelValidate = id_transaction => {
  return request({
    method: 'POST',
    url: `/rules/hotels/rates/validate`,
    data: { id_transaction },
  });
};

export const getHotelCancellationFee = id_transaction => {
  return request({
    method: 'POST',
    url: `/rules/hotels/rates/cancellation-fees`,
    data: { id_transaction },
  });
};

//consultar reserva
export const getBookingDetail = bookingId => {
  const cleanBookingId = String(bookingId).trim();

  return request({
    url: `/hotels/hotels/booking/${cleanBookingId}/details`,
  });
};

export const getMoneyValues = filters => {
  let url = `rules/money-values/dollar-exchange-rate`;

  if (filters) {
    const queryString = toQueryString(filters);
    url = `${url}?${queryString}`;
  }

  return request({
    method: 'GET',
    url: url,
  });
};

export const getHotelSales = (body, detail_transaction) => {
  //pago con tarjeta
  return request({
    method: 'POST',
    url: `/rules/hotels/sales`,
    data: { ...body },
    headers: {
      'x-transaction-id': detail_transaction,
    },
  });
};

export const bookingReserve = (body, id_integration, detail_transaction) => {
  return request({
    method: 'POST',
    url: `/rules/hotels/bookingb2b?id_integration=${id_integration}`,
    data: { ...body },
    headers: {
      'x-transaction-id': detail_transaction,
    },
  });
};

export const getBookingVoucher = params => {
  return request({
    url: `/hotels/hotels/booking/${params.bookingLocator}/voucher?id_integration=${params.id_integration}`,
  });
};

export const sendRegisterFormData = body => {
  return request({
    method: 'POST',
    url: `/hotels/hotels/contact`,
    data: { ...body },
  });
};
export const getDataCard = body => {
  return request({
    method: 'POST',
    url: `/rules/payments/list`,
    data: { ...body },
  });
};

export const sendBookingFormData = body => {
  return request({
    method: 'POST',
    url: `/hotels/hotels/booking/contact`,
    data: { ...body },
  });
};

export const getPaymentPlans = id_service_type => {
  return request({
    url: `/rules/payments-plans?id_service_type=${id_service_type}`,
  });
};

export const getSubsidiariesNew = ({ onlyActive = false } = {}) => {
  const params = new URLSearchParams({
    page: 1,
    per_page: 1000,
    type: 2,
  });

  if (onlyActive) {
    params.append('status', 'active');
  }

  return request({
    url: `/users/entities?${params.toString()}`,
  });
};

export const getSubsidiariesLottery = search => {
  return request({
    url: `/users/entities/all-actives?name_or_description=${search}`,
  });
};
export const getSubsidiary = id => {
  return request({
    url: `/users/entities/${id}`,
  });
};

export const getMainSellers = () => {
  return request({
    method: 'GET',
    url: '/users/users/main-sellers',
  });
};

export const getPlates = () => {
  return request({
    url: `/rules/plates`,
  });
};

export const getPlatesByIdServiceType = id_service_type => {
  return request({
    url: `/rules/plates?group=${id_service_type}`,
  });
};

export const getPlateById = id => {
  return request({
    url: `/rules/plates/${id}`,
  });
};

export const postPlatesForm = data => {
  return request({
    method: 'POST',
    url: '/rules/plates/form',
    data,
  });
};

export const getTaxSituations = () => {
  return request({
    method: 'GET',
    url: `/users/tax-situations`,
  });
};
export const getLotteryByLastSite = () => {
  return request({
    method: 'GET',
    url: `/rules/sorteos/last-site-sorteo`,
  });
};
export const getEntityTypes = () => {
  return request({
    method: 'GET',
    url: `/users/entity-types`,
  });
};

export const getAirports = () => {
  return request({
    method: 'GET',
    url: `/flights/airports?code=`,
  });
};

export const getFlightsById = searchId => {
  return request({
    method: 'POST',
    url: `/rules/flights/search-by-id?id=${searchId}`,
  });
};

export const getFlexibleSearch = body => {
  return request({
    method: 'POST',
    url: 'rules/flights/flexible-search-days',
    data: { ...body },
  });
};

export const getPerzonalizedSearch = body => {
  return request({
    method: 'POST',
    url: 'rules/flights/custom-search',
    data: { ...body },
  });
};

export const getFlights = body => {
  store.dispatch(saveSearchBody(body));
  store.dispatch(
    setSearchLink({
      link: null,
    })
  );
  window.vthws?.webSerch({ ...body });
  return request({
    method: 'POST',
    url: 'rules/flights/search',
    data: { ...body },
  });
};

export const validateFlight = body => {
  return request({
    method: 'POST',
    url: 'rules/flights/new-validate-selected-search',
    data: { ...body },
  });
};

export const createPNR = body => {
  return request({
    method: 'POST',
    url: 'rules/flights/new-create-pnr',
    data: { ...body },
  });
};

export const flightSales = body => {
  return request({
    method: 'POST',
    url: 'rules/flights/sales',
    data: { ...body },
  });
};

export const getSliders = params => {
  let url = 'rules/sliders';
  const queryString = toQueryString(params);
  url = `${url}?${queryString}`;
  return request({
    method: 'GET',
    url,
  });
};

export const getStaticSlider = () => {
  let url = 'rules/sliders/fixed';
  return request({
    method: 'GET',
    url,
  });
};

export const sendFlightsItinerary = body => {
  return request({
    method: 'POST',
    url: 'flights/itinerary/send-to-email',
    data: { ...body },
  });
};

export const saveSearchLink = body => {
  return request({
    method: 'POST',
    url: 'flights/search-link/create',
    data: { ...body },
  });
};

export const getBookingRoomsDetails = id => {
  return request({
    method: 'GET',
    url: `hotels/hotels/booking/room-details/${id}`,
  });
};

//Assist Card

export const getDestinations = () => {
  return request({
    method: 'GET',
    url: `/rules/assist-card/destinations`,
  });
};

export const getAssistQuotes = body => {
  return request({
    method: 'POST',
    url: `/rules/assist-card/quotes/v2`,
    data: body,
  });
};

export const getQuotesPdf = params => {
  let url = `/rules/assist-card/pdf-quote-details`;
  const queryString = toQueryString(params);
  return request({
    method: 'GET',
    url: `${url}?${queryString}`,
  });
};

export const getQuotesDetail = params => {
  let url = `/rules/assist-card/quote-details`;
  const queryString = toQueryString(params);
  return request({
    method: 'GET',
    url: `${url}?${queryString}`,
  });
};

export const refreshQuoteCache = id_transaction => {
  return request({
    method: 'POST',
    url: `/rules/assist-card/refresh-quote-cache`,
    data: {
      id_transaction,
    },
  });
};

export const postAssistEmit = (body, xId) => {
  return request({
    method: 'POST',
    headers: { 'x-transaction-id': xId },
    url: `/rules/assist-card/emit`,
    data: body,
  });
};

export const getAssistCountries = () => {
  return request({
    method: 'GET',
    url: `/rules/assist-card/countries`,
  });
};

export const postAssistPayment = (body, xId) => {
  return request({
    method: 'POST',
    headers: { 'x-transaction-id': xId },
    url: `/rules/assist-card/sales`,
    data: body,
  });
};
export const postCreateCompetitor = body => {
  return request({
    method: 'POST',
    url: 'rules/sorteos/create-participante',
    data: { ...body },
  });
};

export const getAssistBookingDetail = code => {
  const cleanCode = String(code).trim();

  return request({
    url: `/rules/assist-card/emissions/details?code=${cleanCode}`,
  });
};

export const getFlightsBookingDetail = code => {
  const cleanCode = String(code).trim();

  return request({
    method: 'GET',
    url: `/flights/flights/booking/details/${cleanCode}`,
  });
};

export const postNewFavorite = body => {
  return request({
    method: 'POST',
    url: `/hotels/favorite-hotels`,
    data: { ...body },
  });
};

export const postNewOmitted = body => {
  return request({
    method: 'POST',
    url: `/hotels/omitted-hotels`,
    data: { ...body },
  });
};

export const getLastDollarRate = body => {
  return request({
    method: 'GET',
    url: 'rules/money-values/last-git',
    data: { ...body },
  });
};

export const getFullPlatesBookables = () => {
  return request({
    method: 'GET',
    url: `/rules/plates-bookables/full-data`,
  });
};

export const postPlatesPreReserve = body => {
  return request({
    method: 'POST',
    url: `/rules/plates/booking`,
    data: body,
  });
};

export const postPlatesReserve = body => {
  return request({
    method: 'POST',
    url: `/rules/plates/sales`,
    data: body,
  });
};

export const restorageStock = body => {
  return request({
    method: 'POST',
    url: `/rules/plates-stock/restorage-stock`,
    data: body,
  });
};

export const getPublicParameters = params => {
  let url = 'rules/parameters/publics';
  const queryString = toQueryString(params);
  url = `${url}?${queryString}`;
  return request({
    method: 'GET',
    url,
  });
};

export const getIfCanBookNonRef = id_user => {
  let url = 'users/users/' + id_user + '/can-book-non-refundables';
  return request({
    method: 'GET',
    url,
  });
};

export const deleteFavorite = id_favorite_hotel => {
  return request({
    method: 'DELETE',
    url: `/hotels/favorite-hotels/` + id_favorite_hotel,
  });
};

// export const getSiteInformation = (id) => {
//   return request({
//     method: 'GET',
//     url: `/rules/sites/information/${id}`,
//   });
// };

import { siteInformationData } from './siteInformation';

export const getSiteInformation = id => {
  if (siteInformationData[id]) {
    return Promise.resolve(siteInformationData[id]);
  }

  return request({
    method: 'GET',
    url: `/rules/sites/information/${id}`,
  });
};

//payment electronic
export const getPaymentLink = id => {
  return request({
    method: 'GET',
    url: `/rules/payment-links/${id}`,
  });
};

export const getPaymentPlansById = id => {
  return request({
    method: 'GET',
    url: `/rules/payments-plans?id_site=2&id_service_type=${id}`,
  });
};

export const paymentWithCard = (id, body) => {
  return request({
    method: 'POST',
    url: `rules/payments?link=${id}`,
    headers: { 'x-site-id': 2 },
    data: body,
  });
};

export const getintegrations = () => {
  return request({
    method: 'GET',
    url: `/rules/integrations`,
  });
};

export const getProviders = () => {
  return request({
    method: 'GET',
    url: `/rules/providers?page=1&per_page=40`,
  });
};

export const getReferenceOptions = async searchText => {
  return request({
    method: 'GET',
    url: `/hotels/hotels/reference-options?name=${searchText}`,
  });
};

export const alternativeFlights = body => {
  return request({
    method: 'POST',
    url: `rules/flights/alternative-flights`,
    data: body,
  });
};

export const validateSelectedSearch = body => {
  return request({
    method: 'POST',
    url: `rules/flights/validate-selected-search`,
    data: body,
  });
};

export const createPNRStarlings = body => {
  return request({
    method: 'POST',
    url: 'rules/flights/create-pnr',
    data: { ...body },
  });
};

export const postCancelPNR = data => {
  return request({
    method: 'POST',
    url: `flights/flights/cancel-pnr`,
    data,
  });
};

export const getSites = () => {
  return request({
    url: `rules/sites`,
  });
};

export const getSiteContactUs = id_site => {
  return request({
    url: `rules/contact-us/by-site?id_site=${id_site}`,
  });
};

export const getPaymentMethodsBySite = id_site => {
  return request({
    url: `rules/payment-methods/by-site/${id_site}`,
  });
};

export const getProvidersPriority = () => {
  return request({
    url: 'hotels/providers/priorities',
  });
};

// botón arrepentimiento
export const sendRepentance = data => {
  return request({
    method: 'POST',
    url: '/rules/repentance',
    data,
  });
};
